import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0","key":"svg-0"}],["path",{"d":"M14 9a2 2 0 1 1 -4 0a2 2 0 0 1 4 0","key":"svg-1"}],["path",{"d":"M12 16h.01","key":"svg-2"}]]

const IconVacuumCleaner = createReactComponent('outline', 'vacuum-cleaner', 'VacuumCleaner', __iconNode);

export default IconVacuumCleaner;